import { render, staticRenderFns } from "./FederationControlAction.vue?vue&type=template&id=1249785e&scoped=true&"
import script from "./FederationControlAction.vue?vue&type=script&lang=js&"
export * from "./FederationControlAction.vue?vue&type=script&lang=js&"
import style0 from "./FederationControlAction.vue?vue&type=style&index=0&id=1249785e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1249785e",
  null
  
)

export default component.exports